import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  container: {
    backgroundColor: theme.COLOR_BG_BASE, // color dark-light theme verified
    flex: 1,
    justifyContent: 'space-between',
    paddingBottom: rh(24),
  },
  content: {
    flex: 1,
    paddingHorizontal: rw(40),
    paddingTop: rh(32),
  },
  topBlock: {
    rowGap: rh(40),
  },
  titleBlock: {
    rowGap: rh(12),
  },
  title: {
    color: theme.COLOR_TEXT_PRIMARY, // color dark-light theme verified
    fontSize: rf(28),
    letterSpacing: rw(-0.56),
    lineHeight: rh(34),
  },
  subtitle: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(16),
    lineHeight: rh(22),
  },
  codeBlock: {
    rowGap: rh(16),
  },
  digitsRow: {
    justifyContent: 'center',
    columnGap: rw(8),
    flexDirection: 'row',
  },
  digitBox: {
    flex: 1,
    height: rh(72),
    alignItems: 'center',
    backgroundColor: theme.COLOR_BG_SURFACE,
    borderRadius: rw(16),
    justifyContent: 'center',
    maxWidth: rw(64),
  },
  digitErrorBox: {
    backgroundColor: theme.COLOR_BG_CRITICAL_SECONDARY,
  },
  digitSuccessBox: {
    backgroundColor: theme.COLOR_BG_SUCCESS,
  },
  digitValue: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(28),
    letterSpacing: rw(-0.56),
    lineHeight: rf(32.2),
  },
  digitError: {
    color: theme.COLOR_TEXT_CRITICAL,
  },
  digitSuccess: {
    color: theme.COLOR_TEXT_SUCCESS,
  },
  action: {
    paddingHorizontal: theme.SIZE_CONTAINER_PADDING,
    width: '100%',
  },
}))
